import React from 'react';

const MainLayout = ({ children, ...restProps }) => (
  <main {...restProps}>
    <div className={'main-wrapper'}>{children}</div>
  </main>
);

export default MainLayout;
